module.exports = __webpack_public_path__ + "static/author-7-436e1b69314b84b3bb0c3a666aa05b07.jpg";